import PublicationsMobile from './PublicationsMobile'

export default PublicationsMobile
